var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "footer_info" }, [
        _c("ul", [
          _c("li", [
            _c(
              "div",
              { staticClass: "mob_menu" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "blog",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.responsiveMenu = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("blog")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mob_none" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.$store.getters.t("crweb_address"))
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "div",
              { staticClass: "mob_menu" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "contacts",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.responsiveMenu = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("contact")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(1)
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "div",
              { staticClass: "mob_menu" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "faq",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.responsiveMenu = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("FAQ")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(2)
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "div",
              { staticClass: "mob_menu" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "about_us",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.responsiveMenu = false
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$store.getters.t("about_as")) +
                        "\n                        "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mob_none" },
              [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "blog",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("blog")))]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "div",
              { staticClass: "mob_menu" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "vacancy",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("vacancy")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mob_none" },
              [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "vacancy",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("vacancy")))]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "div",
              { staticClass: "mob_none" },
              [
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "faq",
                        params: { lang: _vm.$store.getters.locale }
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("FAQ")))]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_block" }, [
        _c(
          "div",
          { staticClass: "send_mail" },
          [
            _c("p", [_vm._v(_vm._s(_vm.$store.getters.t("write_us")))]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "contacts",
                    param: { lang: _vm.$store.getters.locale }
                  }
                }
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("img", { attrs: { src: "/vue/images/green_mail.png" } }),
                  _vm._v(" "),
                  _c("img", { attrs: { src: "/vue/images/yellow_mail.png" } })
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer_soc" }, [
          _c("div", { staticClass: "block" }, [
            _c("div", { staticClass: "name_block" }, [
              _vm._v(_vm._s(_vm.$store.getters.t("we_in_social")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "soc" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$store.getters.t("facebook_foot_link"),
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", { attrs: { src: "/vue/images/soc_icon_1.png" } }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: { src: "/vue/images/soc_icon_hover_1.png" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$store.getters.t("instagram_foot_link"),
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: "/vue/images/instagram_icon.png" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: { src: "/vue/images/instagram_icon-hover.png" }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm._m(6)
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "/vue/images/map-marker.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mob_none" }, [
      _c("div", { staticClass: "icon" }, [
        _c("img", { attrs: { src: "/vue/images/phone-handset.png" } })
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "tel:+37498587373" } }, [
        _vm._v("+374 98 58 73 73")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mob_none" }, [
      _c("div", { staticClass: "icon" }, [
        _c("img", { attrs: { src: "/vue/images/envelope.png" } })
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "mailto:support@cvweb.ru" } }, [
        _vm._v("support@cvweb.ru")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "/vue/images/bullhorn.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "/vue/images/briefcase.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "/vue/images/question-circle.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.linkedin.com/company/cvweb-ru",
          target: "_blank"
        }
      },
      [
        _c("img", { attrs: { src: "/vue/images/soc_icon_3.png" } }),
        _vm._v(" "),
        _c("img", { attrs: { src: "/vue/images/soc_icon_hover_3.png" } })
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-380cc66c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-380cc66c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/layouts/footer.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-380cc66c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/layouts/footer.vue
// module chunks = 0